import { api } from "lib/api";
import Nav from "shared/Nav";
import Footer from "shared/Footer";
import Meta from "shared/Meta";
import { useState } from "react";
import axios from "axios";
import { useCallback } from "react";
import Image from "shared/Image";
import Link from "next/link";
import ReadingTime from "shared/ReadingTime";
import { useForm } from "react-hook-form";

function fetcher(url) {
  return axios
    .get(`${process.env.NEXT_PUBLIC_GHOST_API_URL}/ghost/api/v3/content${url}`)
    .then(({ data }) => data);
}

function SearchResult({ item }) {
  return (
    <div className="px-2 py-1 bg-white shadow-xl rounded mb-4 mr-4">
      <div className="flex items-center ">
        <div className="w-1/3">
          <div className="p-2 mr-4">
            {item?.feature_image && (
              <Image
                src={item?.feature_image}
                alt={item.title}
                width={64}
                height={64}
                className="rounded-full"
              />
            )}
          </div>
        </div>
        <div className="w-2/3">
          <div className="font-medium uppercase text-blue-900">
            <Link href={item.slug}>
              <a>{item.title}</a>
            </Link>
          </div>
          <ReadingTime post={item} />
        </div>
      </div>
    </div>
  );
}

export default function Search({ settings }) {
  const { register, handleSubmit } = useForm();
  const [data, setData] = useState(null);
  const handleSearch = useCallback((values) => {
    if (values.search) {
      fetcher(
        `/posts?key=${process.env.NEXT_PUBLIC_GHOST_API_KEY}&filter=tag:${encodeURIComponent(
          values.search.replace(/ /g, "-")
        )}&limit=all`
      ).then((data) => setData(data));
    }
  }, []);
  return (
    <div>
      <Meta settings={settings} title={`${settings.title} - Search`} />
      <Nav settings={settings} />
      <div className="container mx-auto min-h-[400px]">
        <h1 className="text-6xl my-4 font-black text-blue-900">Search</h1>
        <hr className="my-4" />
        <form onSubmit={handleSubmit(handleSearch)} className="flex items-stretch mb-4">
          <input
            type="text"
            {...register("search")}
            placeholder="Search..."
            className="shadow-xl border focus:outline-none focus:ring-2 focus:border-0 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-l sm:text-sm border-gray-300 p-2"
          />
          <button
            title="Search"
            className="px-6 text-white bg-blue-900 uppercase font-medium shadow-xl hover:bg-blue-800"
            onClick={handleSearch}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </button>
          <button
            className="px-3 text-white bg-red-500 uppercase font-medium rounded-r shadow-xl hover:bg-red-400"
            onClick={() => setData(null)}
            title="Clear search results."
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              />
            </svg>
          </button>
        </form>
        <div className="grid grid-cols-4">
          {data && data?.posts?.map((item) => <SearchResult item={item} key={item.id} />)}
        </div>
        {!data && (
          <div className="text-gray-400 text-6xl font-black uppercase text-center my-8 tracking-tighter leading-none">
            No Results
          </div>
        )}
        {data && data?.length === 0 && (
          <div className="text-gray-400 text-6xl font-black uppercase text-center my-8 tracking-tighter leading-none">
            No Results
          </div>
        )}
      </div>
      <Footer settings={settings} />
    </div>
  );
}

export async function getStaticProps() {
  const settings = await api.getSettings();
  return {
    props: {
      settings,
    },
  };
}
